module.exports = __webpack_public_path__ + "static/media/app-download-apple_0.da58d1e8.png";